import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { ProductionApp } from './production/ProductionApp.tsx';
import './styles.css';
import './production/production.css';

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <ProductionApp />
  </StrictMode>,
);
